import React, { Component } from 'react'
import { Container, Divider, Image, Segment } from 'semantic-ui-react'
import { AUTH_TOKEN } from '../constants'
import logo from '../images/logo.jpg'

class Header extends Component {
  constructor (props) {
    super(props)
    this.props = props
  }

  render () {
    const authToken = localStorage.getItem(AUTH_TOKEN)

    if (!authToken) return null;

    return (
      <Segment
        vertical
        style={{ margin: '5em 0em 0em', padding: '5em 0em' }}
      >
        <Container textAlign='center'>
          <Divider inverted section />
          <Image
            centered
            size='tiny'
            src={logo}
          />
        </Container>
      </Segment>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Footer.js